import alerts from './alerts';
import user from './user';

export default [...alerts, ...user];
